import { render, staticRenderFns } from "./btn-text-tertiary.vue?vue&type=template&id=9f8a1d50&scoped=true&"
import script from "./btn-text-tertiary.vue?vue&type=script&lang=js&"
export * from "./btn-text-tertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8a1d50",
  null
  
)

export default component.exports